<template>
  <authenticated-layout :back-route="{ name: 'reports' }" :breadcrumbs="breadcrumbItems">
    <page-header
      title="Subject Choice Completion"
      description="Track completion rates for the Subject Choice Selection"
    />

    <BaseReport
      data-endpoint="subject-choice-usage"
      metric-endpoint="subject-choice-usage-ratio"
      additional-metric-endpoint="access-code-usage-ratio"
    >
      <template #metric-content="{ metricData, additionalMetricData }">
        <UsageSummaryMetricTiles
          :data="metricData"
          :adoption-total="additionalMetricData?.total"
          category-title="Total Users"
          category-icon="fa fa-user"
          completed-label="Complete"
          pending-label="Incomplete"
          percentage-label="Completion Rate"
        />
      </template>

      <template #report-content="{ tableData, handleGroupChange, exportReport }">
        <UsageReportTable
          :report-data="tableData"
          @change-group="handleGroupChange"
          @export-report="exportReport"
        />
      </template>
    </BaseReport>
  </authenticated-layout>
</template>

<script setup lang="ts">
import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import {useReportingStore} from "@/store/reporting";
import UsageSummaryMetricTiles from "@/pages/Insights/ReportsDetailPage/components/UsageSummaryMetricTiles.vue";
import UsageReportTable from "@/pages/Insights/ReportsDetailPage/components/UsageReportTable.vue";
import BaseReport from "@/pages/Insights/ReportsDetailPage/components/BaseReport.vue";
import { computed } from "vue";

const reportingState = useReportingStore();
reportingState.resetState();

const breadcrumbItems = computed(() => [
  { text: "Insights", to: { name: "reports" } },
  { text: "Subject Choice Completion", to: null }
]);

reportingState.setAvailableFilters({
  tenants: true,
  institutions: true,
  cohorts: true,
  curriculum: true
});

</script>
